import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Helpsupport.css";

export default function HelpSupport() {
  const navigate = useNavigate();
  // ----- FAQ data (can be swapped with API data later) -----
  const allFaqs = useMemo(
    () => [
      {
        id: "f1",
        q: "Lorem ipsum dolor sit amet?",
        a: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      },
      {
        id: "f2",
        q: "Ut enim ad minim veniam?",
        a: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      },
      {
        id: "f3",
        q: "Duis aute irure dolor in reprehenderit?",
        a: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
      },
      {
        id: "f4",
        q: "Excepteur sint occaecat cupidatat?",
        a: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      },
      {
        id: "f5",
        q: "Sed ut perspiciatis unde omnis?",
        a: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
      },
      {
        id: "f6",
        q: "Nemo enim ipsam voluptatem quia?",
        a: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores.",
      },
    ],
    []
  );

  // ----- Search + accordion state -----
  const [query, setQuery] = useState("");
  const [openId, setOpenId] = useState(null);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return allFaqs;
    return allFaqs.filter(
      (f) => f.q.toLowerCase().includes(q) || f.a.toLowerCase().includes(q)
    );
  }, [allFaqs, query]);

  const toggle = (id) => setOpenId((prev) => (prev === id ? null : id));

  return (
    <div className="help-container">
           <div className="mq-welcome-block">
        <button className="mq-back-btn" onClick={() => navigate('/dashboard')}>
          <span className="mq-back-btn-icon">
            <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
              <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
          Back Home
        </button>
        <h1 className="mq-welcome-name">Help & Support</h1>
      </div>
      {/* Hero / search card */}
      <div className="help-hero card">
        <div className="help-hero-inner">
          <h2 className="hero-title">Need Assistance?</h2>
          <p className="hero-subtitle">
            Lorem Ipsum Dolor Sit Amet, Consectetur Adipisicing Elit, Sed
            Do Eiusmod Tempor Incididunt.
          </p>

          <div className="hero-search">
            <div className="search-input-wrap">
              <svg
                className="search-icon"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14 14L11.1 11.1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search"
                aria-label="Search help articles and FAQs"
              />
            </div>

            <button
              className="submit-btn search-btn"
              onClick={() => {
                // optional: hook this up to a backend search later
              }}
            >
              Search Now
              <svg
                className="arrow-icon"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.33337 8H12.6667"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8 3.33334L12.6667 8.00001L8 12.6667"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* FAQ list */}
      <div className="card">
        <div className="card-head">Frequently Asked Questions</div>

        <ul className="faq-list">
          {filtered.map((item) => {
            const open = openId === item.id;
            return (
              <li key={item.id} className={`faq-item ${open ? "open" : ""}`}>
                <button
                  className="faq-toggle"
                  aria-expanded={open}
                  aria-controls={`faq-panel-${item.id}`}
                  onClick={() => toggle(item.id)}
                >
                  <span className="faq-q">{item.q}</span>
                  <span className="faq-plus" aria-hidden>
                    {open ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M19.002 12.002H5" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12 5V19.002" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M19.002 12.002H5" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    )}
                  </span>
                </button>

                <div
                  id={`faq-panel-${item.id}`}
                  role="region"
                  aria-labelledby={`faq-btn-${item.id}`}
                  className="faq-panel"
                >
                  <p className="faq-a">{item.a}</p>
                </div>
              </li>
            );
          })}

          {filtered.length === 0 && (
            <li className="faq-empty">
              No results for "{query}". Try a different keyword.
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}
